import React from 'react';
import PropTypes from 'prop-types';

import CmsBox from './CmsBox.jsx';

export default function CmsPanel({ trackCmsClick }) {
    function renderCmsBoxes() {
        return FINN.travel.cms.items.map((item, index) => (
            <div key={item.url} className="grid__unit u-pa16">
                <CmsBox
                    title={item.title}
                    imageUrl={item.imageUrl}
                    url={item.url}
                    buttonText={item.buttonText}
                    index={index}
                    trackCmsClick={trackCmsClick}
                />
            </div>
        ));
    }

    return (
        <div className="u-mb64 u-mt32" data-testid="cms-panel">
            <h2 className="u-t2 u-text-center u-ph16">{FINN.travel.cms.title}</h2>
            <div className="grid grid--cols1to3">{renderCmsBoxes()}</div>
        </div>
    );
}

CmsPanel.propTypes = {
    trackCmsClick: PropTypes.func,
};
